<template>
  <div class="spu-comment">
    <div class="title">
      <left-square-outlined @click="onGoBack" />
      <h4>{{ $t('shop.SpuComment.spuComment') }}</h4>
    </div>
    <div v-if="spu_data"
         class="spu-content">
      <div>
        <div class="spu-image-content">
          <img :src="selectImage"
               class="spu-img" />
        </div>
        <div class="spu-thumbnail">
          <div v-for="image in spu_data.customableImages"
               :key="image.id"
               class="spu-thumbnail-box"
               @click="onSelect(image)">
            <img :src="toUrl(findCustomableImage(selectColor!, image))"
                 class="spu-thumbnail-image" />
          </div>
        </div>
      </div>
      <div class="detail">
        <div>
          <div class="detail-name">{{ spu_data.name }}</div>
          <AddToCart ref="addToCart"
                     :hide-info="true"
                     @color-change="colorChange" />
        </div>
        <div>
          <a-button class="detail-cart"
                    type="primary"
                    @click="addProduct">
            {{ $t('shop.SpuComment.addProduct') }}
          </a-button>
        </div>
      </div>
    </div>
    <div class="spu-title">
      <div class="spu-title-box">{{ $t('shop.SpuComment.customComment') }}</div>
    </div>
    <div class="spu-search">
      <div v-for="(list, index) in search_list"
           :key="index"
           class="spu-search-box">
        <div :class="select_search.label == list.label ? 'select-search' : ''"
             @click="selectClick(list)">
          {{ list.label }}({{ list.count }})
        </div>
      </div>
    </div>
    <div v-for="item in comment_list"
         :key="item.id"
         style="display: flex;">
      <div class="comment-gravatar">
        <img v-if="item.comment[0].is_anonymous"
             :src="default_avatar"
             class="comment-img" />
        <img v-else
             :src="gravatar(item.user)"
             class="comment-img" />

      </div>
      <div class="spu-comment-box">
        <FlashbaseCommentContent :item="item.item"
                                 :data="item.comment"
                                 :is-order="false"
                                 :is-custom="true"
                                 :is-admin="false"
                                 @submit-reply="submitReply">
          <template #appendComment>
            <FlashbaseCommentAppend :append-list="commentDate(item.comment)"
                                    :created-at="item.comment[0].createdAt"></FlashbaseCommentAppend>
            <FlashbaseCommentReply :is-detail="false"
                                   :is-custom="true"
                                   :page-size="paginationSize"
                                   :current="paginationCurrent"
                                   :is-admin="false"
                                   :comment-id="item.comment[0].id"
                                   :user-id="item.comment[0].user.id"
                                   :append-list="item.comment[0].commentReplys"
                                   :created-at="item.comment[0].createdAt"
                                   @submit-reply="submitReply"></FlashbaseCommentReply>
          </template>
        </FlashbaseCommentContent>
      </div>

    </div>
    <div class="page-content">
      <APagination v-model:current="paginationCurrent"
                   v-model:pageSize="paginationSize"
                   :page-size-options=paginationSizeOptions
                   :show-size-changer="true"
                   :total="paginationTotal"
                   @change="changePagination" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRoute, useRouter } from "vue-router"
import { spusComment, getSpuDetail, spusDetail, spusCount } from "../api/categories"
import { findCustomableImage, sortBy } from "../../custom-spus/utils"
import { onMounted, ref, nextTick } from "vue"
import AddToCart from '../../custom-spus/view/components/AddToCart.vue'
import default_avatar from '../assets/default_avatar.png'
import { toUrl } from '@/utils'
import BigNumber from "bignumber.js"
const route = useRoute()
const router = useRouter()
BigNumber.config({ ROUNDING_MODE: 1 })

const comment_list = ref<any>()
onMounted(async () => {
  const spuCommentData = sessionStorage.getItem('spuCommentData') as any
  const data = JSON.parse(spuCommentData)
  if (data) {
    paginationSize.value = data.limit
    paginationCurrent.value = data.offset
  }
  await init()
  sessionStorage.clear()
})
const spu_data = ref<any>()
const sku_data = ref<any>()
const selectImage = ref<string>('')
const selectImageId = ref<number>(0)
const init = async () => {
  const id = route.params.id as any
  const category_id = route.query.categoryId as any
  spu_data.value = await getSpuDetail(category_id, id)
  selectImageId.value = spu_data.value.customableImages[0].id

  sku_data.value = await spusDetail(id)

  const product = createProduct()
  if (product) {
    nextTick(() => {
      addToCart.value.setProduct(product)
    })
  }

  await initComment()
  search_list.value = await spusCount(id)
  select_search.value = search_list.value[0]
}
const initComment = async () => {
  const id = route.params.id as any
  const params = {
    limit: paginationSize.value,
    offset: new BigNumber(paginationSize.value).times(new BigNumber(paginationCurrent.value).minus(1)).toNumber()
  }
  const searchData = select_search.value ? Object.assign({ value: select_search.value.value }, params) : params
  await spusComment(id, searchData).then((res: any) => {
    paginationTotal.value = res.count
    comment_list.value = []
    res.comments.forEach((r: any) => {
      comment_list.value.push({
        comment: [r],
        item: r.item,
        user: r.user
      })
    })
  })

}
const search_list = ref<any>()
const select_search = ref<any>()
const selectColor = ref<any>({
  value: '',
  name: ''
})
const onSelect = (item: any) => {
  selectImage.value = toUrl(
    findCustomableImage(
      selectColor.value,
      item
    )
  )!
  selectImageId.value = item.id
}
const colorChange = (value: any) => {
  selectColor.value = value.color
  const selectSku = spu_data.value.customableImages.filter((el: any) => {
    return el.id == selectImageId.value
  })
  selectImage.value = toUrl(
    findCustomableImage(
      value.color,
      selectSku[0]
    )
  )!
}

const paginationTotal = ref(0)
const paginationSize = ref(5)
const paginationSizeOptions = ref([5, 10, 20, 50])
const paginationCurrent = ref(1)
// 分页
const changePagination = async (page: number, pageSize: number) => {
  paginationSize.value = pageSize
  paginationCurrent.value = page
  await initComment()
}

const submitReply = async () => {
  await initComment()
}
const commentDate = (data: any) => {
  // eslint-disable-next-line vue/no-mutating-props, vue/no-side-effects-in-computed-properties
  return data[0].children ? data[0].children.sort(sortBy('createdAt', true)) : []
}
const gravatar = (user: any) => {
  return toUrl(user.gravatar) || default_avatar
}
const onGoBack = () => {
  // router.push(`/console/accounts/comment`)
  router.go(-1)
}
const selectClick = async (value: any) => {
  select_search.value = value
  paginationCurrent.value = 1
  paginationSize.value = 5
  await initComment()
}
const createProduct = () => {
  return {
    is_custom: false,
    spu_id: spu_data.value.id,
    image: spu_data.value.customableImages,
    skus: sku_data.value.skus,
    customizedImages: null,
    name: "",
    spu_name: spu_data.value.name,
    custom_spu_id: null,
    price_detail: {
      spu_price: spu_data.value.price
    }
  }
}
const addToCart = ref<any>()


const addProduct = () => {
  addToCart.value.addProduct()
}
</script>
<style scoped lang="less">
.spu-comment {
  padding: 20px;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding-top: 0;

  .title {
    position: sticky;
    top: 0;
    display: flex;
    height: 30px;
    line-height: 30px;
    width: 100%;
    align-items: center;
    border-bottom: 1px solid #e9e9e9;
    padding: 20px 0;
    margin-bottom: 20px;
    background: #fff;
    z-index: 1000;

    h4 {
      margin: 0 0 0 10px;
    }
  }

  .spu-content {
    display: flex;

    .detail {
      flex: 1;
      // line-height: 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .detail-name {
        font-size: 20px;
        color: #111111;
        min-width: 100px;
        text-align: start;
      }

      .detail-price {
        color: #DE4A09;
        font-size: 24px;
      }

      .colors {
        display: flex;
        flex-wrap: wrap;
        gap: 14px;
        align-items: center;
        margin: 10px 0;

        .color-item {
          width: 35px;
          height: 35px;
          border: 1px solid #cdcdcd;
          cursor: pointer;
          border-radius: 50%;
        }

        .color-selected {
          margin: 5px;
          width: 25px;
          height: 25px;
        }
      }

      .size-content {
        display: flex;
        margin-bottom: 18px;
        flex-wrap: wrap;
        gap: 10px;
        margin: 10px 0;

        .size-item {
          border: 1px solid #d9d9d9;
          padding: 0 10px;
          cursor: pointer;
          height: 40px;
          min-width: 140px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .size-selected {
          background-color: #111111;
          color: white;
        }
      }

      .quantity-input {
        width: 124px;
        text-align: center;

        :deep(.ant-input-group-addon) {
          padding: 0;
          width: 32px;
          height: 32px;
        }

        :deep(.ant-input) {
          height: 32px;
          padding: 0;
        }

        .input-change {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          background-color: #F6F6F6;
        }

        .input-disabled {
          cursor: not-allowed;
        }
      }
    }

    .detail-cart {
      width: 120px;
      height: 40px;
      float: right;
    }

    .spu-image-content {
      width: 440px;
      height: 440px;
      background: #F6F6F6;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 30px;

      .spu-img {
        width: 388px;
        height: 399px;
      }

    }

    .spu-thumbnail {
      width: 440px;
      margin: 10px 0;
      display: flex;
      overflow-x: scroll;
      overflow-y: hidden;

      .spu-thumbnail-box {
        margin-right: 10px;
      }

      .spu-thumbnail-image {
        width: 72px;
      }
    }
  }

  .spu-title {
    width: 100%;
    margin: 20px 0;
    height: 40px;
    border-bottom: 1px solid #eee;

    .spu-title-box {
      width: 100px;
      height: 40px;
      line-height: 40px;
      margin-left: 20px;
      border-bottom: 2px solid #111;
      text-align: center;
    }
  }

  .spu-search {
    display: flex;
    font-size: 16px;
    color: #999;

    .spu-search-box {
      height: 16px;
      line-height: 16px;
      padding: 0 20px;
      margin: 20px 0 40px 0;
      border-right: 1px solid #ccc;
      cursor: pointer;
    }

    .spu-search-box:last-child {
      border-right: none;
    }

    .select-search {
      color: #111;
    }
  }

  .comment-gravatar {
    margin-right: 15px;

    .comment-img {
      width: 64px;
      height: 64px;
      border-radius: 32px;
    }
  }

  .spu-comment-box {
    flex: 1;
    margin-bottom: 20px;
  }

  .page-content {
    float: right;
  }
}
</style>


